<template>
  <header>
    <nav class="navigation">
      <div class="container">
        <div class="nav-cont">
          <div class="logo-div">
            <router-link :to="{ name: 'Home' }">
              <img src="@/assets/images/GeneralAssets/LogoGiveAndGet.svg" alt="Give & Get Logo">
            </router-link>

            <h3>We make a living by <span class="red">WHAT WE GET</span>, <br>but we make a life by <span class="vv">WHAT WE GIVE</span> </h3>

            <h4>-Winston Churchill</h4>
          </div>

          <ul class="ul-links">
            <li><router-link :to="{ name: 'Accounts' }">{{ $tc('header.accounts') }}</router-link></li>
            <li v-if="false"><router-link :to="{ name: 'Rewards' }">{{ $tc('header.rewards') }}</router-link></li>
            <li><router-link :to="{ name: 'WhoWeAre' }">{{ $tc('header.whoweare') }}</router-link></li>
            <li><router-link :to="{ name: 'Contact' }">{{ $tc('header.contact') }}</router-link></li>
          </ul>
          <ul class="ul-links-2">
            <li><a href="https://secure.finanleads.com/login" target="_blank">{{ $tc('header.log_in') }}</a></li>
            <li><a class="reg" href="https://secure.finanleads.com/register" target="_blank">{{ $tc('header.register') }}</a></li>
            <li class="lang"><a @click="switchLang()">{{ $i18n.locale === 'en' ? 'ES' : 'EN' }}</a></li>
          </ul>

          <div class="burger-div" >
            <button type="button" :class="{open : menuOpen }"  class="burger" @click="menuOpen = !menuOpen" >
              <span class="burger-top"></span>
              <span class="burger-bottom"></span>
              <span class="burger-b2"></span>
            </button>
          </div>
        </div>
      </div>
    </nav>

    <div
      v-show="menuOpen"
      class="mobile-nav">
      <div class="mobile-wrap">
        <ul class="nav-links-m">
          <li><router-link :to="{ name: 'Accounts' }" @click="menuOpen = false">{{ $tc('header.accounts') }}</router-link></li>
          <li v-if="false"><router-link :to="{ name: 'Rewards' }" @click="menuOpen = false">{{ $tc('header.rewards') }}</router-link></li>
          <li><router-link :to="{ name: 'Mundial' }" @click="menuOpen = false">{{ $tc('header.mundial') }}</router-link></li>
          <li><router-link :to="{ name: 'WhoWeAre' }" @click="menuOpen = false">{{ $tc('header.whoweare') }}</router-link></li>
          <li><router-link :to="{ name: 'Contact' }" @click="menuOpen = false">{{ $tc('header.contact') }}</router-link></li>
          <li><a href="https://secure.finanleads.com/login" target="_blank">{{ $tc('header.log_in') }}</a></li>
          <li><a href="https://secure.finanleads.com/register" target="_blank">{{ $tc('header.register') }}</a></li>
          <li class=""><a @click="switchLang()">{{ $i18n.locale === 'en' ? 'ES' : 'EN' }}</a></li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data () {
    return {
      menuOpen: false
    }
  },

  methods: {
    switchLang () {
      this.$i18n.locale = this.$i18n.locale === 'en' ? 'es' : 'en'
    }
  }
}
</script>

<style lang="scss" scoped>
  .lang {
    a {
      color: #fff;
      cursor: pointer;
    }
  }
</style>
